import CustomError from './CustomError'

export default class UserAccountExpiredException extends CustomError {
  constructor(message: string) {
    super(message)
  }
}
